import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { RootState } from '../../../redux/store';
import {
  customOrder,
  iconBgColorMap,
  useNavigation
} from '../constants/navigation';
import DashboardCard from './DashboardCard';
import { Adminprops, NavItem } from '../types';
import { CardContainer, ChildItem, ColumnsWrapper } from './styled';

const AdminHome = ({
  setSelectedPage,
  closeDropdown,
  schoolConfig
}: Adminprops) => {
  const { user } = useSelector((state: RootState) => state.profile);
  const navigation = useNavigation(schoolConfig);
  const sortedItems = useMemo(() => {
    return navigation
      .filter((item) => item.title !== 'Home')
      .sort(
        (a, b) => customOrder.indexOf(a.title) - customOrder.indexOf(b.title)
      );
  }, [navigation]);

  const handleMenuItemClick = (item: NavItem) => () => {
    if (setSelectedPage) {
      setSelectedPage(String(item.value));
      closeDropdown();
    }
    if (!isEmpty(item?.mixpanelEvent)) {
      mixpanel.track(`${item.mixpanelEvent}`, {
        session_type: 'admin_app',
        origin: 'tiles',
        'Tiles menu item clicked': new Date().toISOString(),
        user_email: user?.email
      });
    }
  };

  return (
    <ColumnsWrapper>
      {sortedItems.map((section) => (
        <CardContainer key={String(section.value)}>
          <DashboardCard
            title={section.title}
            icon={
              section.icon?.white
                ? React.createElement(section.icon.white)
                : null
            }
            iconBgColor={iconBgColorMap[String(section.value)] ?? '#f0f0f0'}
          >
            {section.children?.map((item) => (
              <ChildItem
                key={String(item.value)}
                variant='body2'
                onClick={handleMenuItemClick(item)}
              >
                • &nbsp;{item.title}
              </ChildItem>
            ))}
          </DashboardCard>
        </CardContainer>
      ))}
    </ColumnsWrapper>
  );
};

export default AdminHome;
